import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useAuthentication, useUnsavedChanges } from '@connect-x-app/hybrid-state';
import { AdminConfigPermissions, SmartAction } from '@connect-x-app/shared-domain-models';
import { useForm } from '@connect-x-app/web-state';
import { Spinner } from '@connect-x-app/web-ui';

import { validateSmartActionForm } from '../hooks/useSmartActionValidation';
import { useCreateSmartAction } from '../queries';
import { SmartActionForm } from './SmartActionForm';

import './SmartAction.scss';

const initialForm: SmartAction = {
  apiKey: '',
  description: '',
  id: '',
  isDefault: false,
  isRequestPublic: false,
  isResponsePublic: false,
  keywords: [],
  name: '',
  url: '',
};

export const CreateSmartAction = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const { hasPermission } = useAuthentication();

  const { setHasUnsavedChanges } = useUnsavedChanges();

  const { isPending, mutate } = useCreateSmartAction({
    onSuccess: async () => {
      await setHasUnsavedChanges(false);
      navigate('/admin/connect');
    },
  });

  const form = useForm<SmartAction>({
    initialForm,
    submitForm: values => mutate(values),
    validateForm: values => validateSmartActionForm(values),
  });

  if (isPending) {
    return <Spinner overlay>{t('SHARED.LOADING_APPLICATION')}</Spinner>;
  }

  return (
    <main className="smart-action-container">
      <SmartActionForm canSave={hasPermission(AdminConfigPermissions.WRITE)} form={form} />
    </main>
  );
};
